<script setup lang="ts">
import { WifiOff } from 'lucide-vue-next'
import { useOnlineStatus } from '@/composables/useOnlineStatus'
import { useI18n } from 'vue-i18n'

/**
 * "You are offline", in the page rather than stuck to the top of the viewport.
 *
 * It used to be a sticky brand-red strip above the top bar, which meant it covered the back arrow
 * and the page title on every scroll — and red is this app's "press this", not its "careful". Amber,
 * in the flow of the page, under the heading it qualifies.
*/
const { isOnline } = useOnlineStatus()
const { t } = useI18n()
</script>

<template>
  <div
    v-if="!isOnline"
    class="mb-4 flex items-center justify-center gap-2 rounded-tile bg-warning px-4 py-3 text-meta font-bold text-warning-foreground"
    role="status"
  >
    <WifiOff
      class="h-5 w-5 shrink-0"
      aria-hidden="true"
    />
    <span>{{ t('common.offlineMode') }}</span>
  </div>
</template>
